import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/useAuth.js';

const DEVICE_PLANE_LINKS = [
  { label: 'Overview', to: '/device-plane', end: true },
  { label: 'Live Status', to: '/device-plane/status' },
  { label: 'Fleet', to: '/device-plane/fleet' },
  { label: 'Commands', to: '/device-plane/commands' },
  { label: 'Sensors', to: '/device-plane/sensors' },
  { label: 'Pipeline', to: '/device-plane/pipeline' },
  { label: 'Connections', to: '/device-plane/connections' },
  { label: 'Device health', to: '/device-plane/health' },
];

export function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <div className="flex min-h-screen bg-page">
      {/* Sidebar — demo styling */}
      <aside className="w-56 bg-surface border-r border-white/10 flex flex-col sticky top-0 h-screen">
        <div className="px-4 py-5 border-b border-grid">
          <p className="font-bold text-lg text-ink">Device Plane</p>
          <p className="text-xs text-muted mt-0.5">Haron middleware</p>
        </div>
        <nav className="flex-1 py-3 px-2 space-y-0.5">
          {DEVICE_PLANE_LINKS.map(({ label, to, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end ?? false}
              className={({ isActive }) =>
                `block px-3 py-2 rounded-lg text-sm transition-colors ${
                  isActive ? 'bg-accent text-white' : 'text-ink2 hover:bg-surface2 hover:text-ink'
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="px-4 py-4 border-t border-grid">
          <p className="text-xs text-muted truncate mb-2">{user?.mobile ?? ''}</p>
          <button
            onClick={handleLogout}
            className="w-full text-left text-sm text-ink2 hover:text-ink transition-colors"
          >
            Logout
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
